import { useCallback } from "react";

import { PlatformListItem } from "@/types";
import { buildScopedPath } from "@/utils/common";

/** The platform fields needed to resolve its scoped settings href. */
export type PlatformSettingsHrefInput = Pick<PlatformListItem, "id">;

const SETTINGS_REST_PATH = "platforms/manage/current";

/**
 * Resolves the scoped settings URL for a platform (the PlatformSelect gear, the
 * platforms-list title link and its row actions).
 *
 * Opening a platform's settings switches the URL scope INTO that platform (a
 * platform is its own context) in the **platform-only** form — the `/entity/:o`
 * segment is dropped, exactly like `switchOrganization(null)` / the "Whole
 * platform" scope, so no organization context leaks into platform management.
 * `CurrentOrganizationProvider` honors the org-less URL for anyone holding a
 * capability on the target platform's PLATFORM node (`useCanSelectWholePlatform`
 * semantics) and falls back to the platform's data-owner org otherwise.
 * Navigating to a different platform's settings switches the platform scope via
 * the URL itself — no `switchPlatform` intent, so the enforcer honors the
 * target platform id as-is.
 */
export const useGetPlatformSettingsHref = () =>
  useCallback(
    (platform: PlatformSettingsHrefInput): string =>
      buildScopedPath(platform.id, null, null, SETTINGS_REST_PATH),
    []
  );
